import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { omit } from 'ramda';
import { getURLParams } from 'js/utils/url.util';

/* Buzz override: replace navigate logic to basic history replace */
export const useRemoveQueryParams = () => {
    const history = useHistory();
    const { search } = useLocation();
    const params = getURLParams(search);

    return useCallback(removeParams => {
        history.replace({
            search: `?${new URLSearchParams(omit(Array.isArray(removeParams) ? removeParams : [removeParams], params)).toString()}`
        });
    }, [history, params]);
};
